export default __webpack_public_path__ + "static/media/bloc_blanc_fakechoice_large.8eab2c32.png";